import styles from "./FolderTile.module.css";
import cn from "classnames";
import { getColor, getIcon } from "../CreateFolder/themeOptions";
import { Badge } from "src/components/ui-components/Badge/Badge";
import { IconSquareHalf } from "src/components/ui-components/Icons/IconSquareHalf";
import Link from "next/link";
import { Tooltip } from "src/components/ui-components/Tooltip/Tooltip";

interface Props {
  icon: string;
  color: string;
  name: string;
  path: string;
  contentLength?: number;
  description?: string;
  tiny?: boolean;
}

export function FolderTile(props: Props) {
  const { description, tiny = false } = props;

  return tiny && description !== undefined && description !== "" ? (
    <Tooltip label={description} position="below-center">
      <div>
        <TileContent {...props} />
      </div>
    </Tooltip>
  ) : (
    <TileContent {...props} />
  );
}

function TileContent(props: Props) {
  const { name, contentLength, path, description, tiny = false } = props;
  const icon = getIcon(props.icon);
  const color = {
    "--customColor": `${getColor(props.color)}`,
  } as React.CSSProperties;

  return (
    <Link
      href={`/workspace/library${path}`}
      className={cn(styles.tile, tiny && styles.tiny)}
      style={color}
    >
      <div className={cn(styles.content, tiny && styles.tiny)}>
        <div className={styles.folderIcon}>{icon}</div>
        <div className={styles.folderDetails}>
          <h1 className={styles.folderName}>{name}</h1>
          {!tiny && <div className={styles.description}>{description}</div>}
        </div>
      </div>
      {!tiny && (
        <div className={styles.footer}>
          {contentLength !== undefined && (
            <Badge size="M" variant="filled" color="neutral">
              <IconSquareHalf />
              {contentLength}
            </Badge>
          )}
        </div>
      )}
    </Link>
  );
}
